import { useState } from 'react';

import { Alert, AlertDescription, AlertTitle, Button } from 'design-system';
import { Save, Users } from 'lucide-react';
import { useNavigate } from 'react-router';

import { ConfirmationDialog } from '@/features/dashboard/components/ConfirmationDialog';

export const SharedDashboardBanner = ({
  user,
  onSave,
  isSaving,
  dashboardName,
  isLoading
}: {
  user: string;
  onSave: () => void;
  isSaving: boolean;
  dashboardName: string;
  isLoading: boolean;
}) => {
  const navigate = useNavigate();
  const [dismissDialogOpen, setDismissDialogOpen] = useState(false);

  return (
    <div className='mt-6'>
      <Alert className='border-primary/20 bg-primary/5 px-4 py-3'>
        <Users
          aria-hidden='true'
          className='text-primary'
        />
        <div className='col-start-2 flex flex-col justify-between gap-4 lg:flex-row lg:items-center'>
          <div>
            <AlertTitle className='mb-1 text-base font-semibold'>
              Dashboard shared with you
            </AlertTitle>
            <AlertDescription>
              <span className='font-semibold text-foreground'>{user}</span> shared "{dashboardName}"
            </AlertDescription>
          </div>
          <div className='flex flex-col gap-2 sm:flex-row'>
            <Button
              disabled={isSaving}
              variant='outline'
              onClick={() => {
                setDismissDialogOpen(true);
              }}
            >
              Dismiss
            </Button>
            <Button
              disabled={isSaving || isLoading}
              onClick={onSave}
            >
              <Save aria-hidden='true' />
              Save to My Dashboards
            </Button>
          </div>
        </div>
      </Alert>
      <ConfirmationDialog
        cancelText='Keep browsing'
        confirmText='Dismiss dashboard'
        destructive
        open={dismissDialogOpen}
        text='You are about to dismiss this shared dashboard'
        title="Don't save this dashboard?"
        onCancel={() => {
          setDismissDialogOpen(false);
        }}
        onConfirm={() => {
          setDismissDialogOpen(false);
          navigate('/dashboard');
        }}
      />
    </div>
  );
};
